export const GET_POPULAR_LOCATIONS = "GET_POPULAR_LOCATIONS";
